
define('text!templates/appMain/privilegedMain/qm/policies/editors/numberSelector.html',[],function () { return '<input class="numberSelector" data-bind="value: numberValue, valueUpdate: &apos;input&apos;">';});

